import React from 'react';
import s from '../Torpedo.scss';
var TorpedoContentStrip = function (_a) {
    var contentStrip = _a.contentStrip, contentStripOffset = _a.contentStripOffset, strip = _a.strip;
    var requestIdx = contentStripOffset || 0 + 1;
    if (!contentStrip || strip.idx !== requestIdx) {
        return null;
    }
    return (React.createElement("div", { key: "row-content-strip-" + strip.idx, className: s['strip'], style: {
            width: strip.width,
        } }, contentStrip));
};
TorpedoContentStrip.displayName = 'TorpedoContentStrip';
export default TorpedoContentStrip;
//# sourceMappingURL=ContentStrip.js.map